import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import { cn } from '~/src/lib/utils'
import { renderRichText } from './richText'
import type { HubDecisionBlockSection, HubSectionComponentProps } from './types'

const TONE_CLASSES: Record<HubDecisionBlockSection['tone'], string> = {
  info: 'border-info-100 bg-info-50',
  neutral: 'border-border bg-accent',
}

const TONE_KICKER_CLASSES: Record<HubDecisionBlockSection['tone'], string> = {
  info: 'text-info-700',
  neutral: 'text-ds-text-quaternary',
}

const TONE_LINK_CLASSES: Record<HubDecisionBlockSection['tone'], string> = {
  info: 'text-info-700',
  neutral: 'text-foreground',
}

export function HubDecisionBlock({
  section,
}: HubSectionComponentProps<HubDecisionBlockSection>) {
  return (
    <aside
      id={section.id}
      className={cn(
        'flex flex-col gap-1 rounded-2xl border px-5 py-4',
        TONE_CLASSES[section.tone]
      )}
    >
      <p
        className={cn(
          'text-xs font-semibold uppercase tracking-wide',
          TONE_KICKER_CLASSES[section.tone]
        )}
      >
        {section.kicker}
      </p>
      <Link
        href={section.linkHref}
        className={cn(
          'inline-flex items-center gap-1 text-lg font-semibold hover:underline',
          TONE_LINK_CLASSES[section.tone]
        )}
      >
        {section.linkLabel}
        <ArrowRight className='size-4' aria-hidden />
      </Link>
      {section.supportText && (
        <p className='text-sm leading-5 text-foreground-secondary'>
          {renderRichText(section.supportText)}
        </p>
      )}
    </aside>
  )
}
